import axios from 'axios';
import { showLoader, hideLoader } from '../utils/aero-loader';

const API_URL = import.meta.env.VITE_APPOINTMENTS_API_URL;

const api = axios.create({
  baseURL: API_URL,
});

// REQUEST → show loader
api.interceptors.request.use(
  (config) => {
    showLoader();
    return config;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  },
);

// RESPONSE → hide loader
api.interceptors.response.use(
  (response) => {
    hideLoader();
    return response;
  },
  (error) => {
    hideLoader();
    return Promise.reject(error);
  },
);

export default api;
